import {
  makeStyles,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@material-ui/core";
import { Fragment, useState } from "react";
import { useRefresh, useNotify, useMutation, Button } from "react-admin";
import SaveIcon from "@material-ui/icons/Save";

interface IActivateStudentButton {
  studentId: string;
}

const CustomConfirmButton = ({ studentId }: IActivateStudentButton) => {
  const refresh = useRefresh();
  const notify = useNotify();

  const [handleChangeStatusStudent, { loading }] = useMutation(
    {
      type: "customUpdate",
      resource: `students/${studentId}/activate`,
      payload: {},
    },
    {
      onSuccess: ({ data }) => {
        notify(
          `Successfully activate student. Make sure to update the Student Schedules.`,
          "info"
        );
        refresh();
      },
      onFailure: (error) =>
        notify(
          `Failed activate the student, error: ${error.message}`,
          "warning"
        ),
    }
  );

  return (
    <Button
      onClick={handleChangeStatusStudent}
      color="primary"
      label={loading ? "Please wait..." : "Confirm"}
      autoFocus
    >
      <SaveIcon />
    </Button>
  );
};

const ActivateStudentButton = ({ studentId }: IActivateStudentButton) => {
  const [open, setOpen] = useState<boolean>(false);

  const useStyles = makeStyles({
    dialog: {
      "& .MuiDialog-paper": {
        overflowY: "unset",
      },
    },
    table: {
      marginTop: "10px",
      minWidth: 650,
      padding: "1rem",
    },
  });

  const classes = useStyles();

  const handleOpenDialog = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Fragment>
      <Button label={`Activate Student`} onClick={handleOpenDialog} />
      <Dialog
        open={open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className={classes.dialog}
        maxWidth="md"
      >
        <DialogTitle id="alert-dialog-title">Activate The Student</DialogTitle>
        <DialogContent>
          <DialogContentText color="initial">
            Are you sure to Activate the student ?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="secondary" label="Back" />
          <CustomConfirmButton studentId={studentId} />
        </DialogActions>
      </Dialog>
    </Fragment>
  );
};

export default ActivateStudentButton;
